<template>
    <div class="myskov-area__content">
        <!--Default screen when the user is not logged in-->
        <login v-if="page == 'login'" @forgetpw="gotoForgetPw" @newaccount="gotoNewAccount"></login>
        <!--New user screen-->
        <new-user v-if="page == 'new-user'"></new-user>
        <!--Forgot PW screen-->
        <forget-pw v-if="page == 'forgotpw'"></forget-pw>
    </div>
</template>

<script>
import Login from './login.vue';
import NewUser from './new-user.vue';
import ForgetPw from './forget-pw.vue';

export default {
    data() {
        return {
            translations: APP_CONFIG.TRANSLATION.LOGIN_AREA
        }
    },
    methods: {
        gotoForgetPw() {
            this.$router.push({
                path: '/myskov/forgotpw'
            })
        },
        gotoNewAccount() {
            this.$router.push({
                path: '/myskov/new-user'
            })
        }
    },
    computed: {
        page() {
            return this.$route.params.page;
        }
    },
    components: {
        Login,
        NewUser,
          ForgetPw
    }
}
</script>

